/**
 * Query keys for the DB-only thread cache.
 *
 * Their own module so the fetch and the hook can both reach them without an
 * import cycle - the same reason `use-email-index` keeps `email-index-key.ts`
 * separate. The hook re-exports them, so consumers are unaffected.
 */
export const emailThreadDbKeys = {
  all: ['email-thread-db'] as const,
  org: (orgId: string | undefined) => [...emailThreadDbKeys.all, orgId] as const,
  thread: (orgId: string | undefined, threadId: string | undefined) =>
    [...emailThreadDbKeys.org(orgId), threadId] as const,
};
